export default __webpack_public_path__ + "static/media/offer-accepted.6ce944be.svg";